import { Instagram, Mail, Phone, MapPin } from "lucide-react";
import { scrollToId } from "../../lib/motion";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-cream/70">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
      <div className="md:col-span-5">
        <div className="inline-block bg-cream rounded-2xl p-5">
          <img src="/okome-logo.png" alt="OKOME Catering" className="h-28 w-auto" />
        </div>
        <p className="mt-6 font-serif italic text-xl text-cream/60 max-w-sm">
          Handmade Japanese catering in Auckland.
        </p>
      </div>

      <div className="md:col-span-3">
        <span className="label-caps text-cream/40">Explore</span>
        <div className="mt-4 flex flex-col gap-2">
          {["about", "menu", "services", "gallery", "faq"].map((id) => (
            <button
              key={id}
              onClick={() => scrollToId(id)}
              className="text-left capitalize hover:text-gold transition-colors"
            >
              {id}
            </button>
          ))}
        </div>
      </div>

      <div className="md:col-span-4">
        <span className="label-caps text-cream/40">Contact</span>
        <div className="mt-4 flex flex-col gap-3">
          <a href="tel:+6402108010017" className="flex items-center gap-3 hover:text-gold transition-colors">
            <Phone size={16} /> 0210 801 0017 (Miwa)
          </a>
          <a href="mailto:okomecateringnz@gmail.com" className="flex items-center gap-3 hover:text-gold transition-colors">
            <Mail size={16} /> okomecateringnz@gmail.com
          </a>
          <a href="https://instagram.com/okomecatering.nz" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-gold transition-colors">
            <Instagram size={16} /> @okomecatering.nz
          </a>
          <span className="flex items-start gap-3 text-cream/50">
            <MapPin size={16} className="mt-0.5" /> Edwin Street, Mount Eden, Auckland
          </span>
        </div>
      </div>
    </div>
    <div className="border-t border-cream/10">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/40">
        <span>© {new Date().getFullYear()} OKOME Catering. Japanese Catering in Auckland.</span>
        <a href="#" className="hover:text-gold transition-colors">Privacy Policy</a>
      </div>
    </div>
  </footer>
);
